import '../pages/AdminPages.css';

const renderBlocks = (count, className) =>
  Array.from({ length: count }, (_, index) => (
    <div key={`${className}-${index}`} className={className} />
  ));

const AdminPageSkeleton = ({
  title = 'Načítavam',
  subtitle = 'Pripravujem obsah stránky',
  variant = 'table',
  showAction = true
}) => {
  const renderTableRows = (rows = 6) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`row-${index}`} className="admin-skeleton-table-row">
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
        <div className="admin-skeleton-cell admin-skeleton-cell-md" />
        <div className="admin-skeleton-cell admin-skeleton-cell-md" />
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
      </div>
    ));

  const renderVariant = () => {
    switch (variant) {
      case 'dashboard':
        return (
          <>
            <div className="admin-skeleton-kpi-grid">
              {renderBlocks(4, 'admin-skeleton-kpi-card')}
            </div>
            <div className="admin-skeleton-panels-grid">
              <div className="admin-skeleton-panel admin-skeleton-panel-tall" />
              <div className="admin-skeleton-panel admin-skeleton-panel-tall" />
            </div>
          </>
        );
      case 'services':
        return (
          <>
            <div className="admin-skeleton-toolbar">
              <div className="admin-skeleton-input admin-skeleton-input-lg" />
              <div className="admin-skeleton-chip" />
            </div>
            <div className="admin-skeleton-list">
              {renderBlocks(5, 'admin-skeleton-list-item')}
            </div>
          </>
        );
      case 'calendar':
        return (
          <>
            <div className="admin-skeleton-toolbar">
              <div className="admin-skeleton-chip" />
              <div className="admin-skeleton-chip" />
              <div className="admin-skeleton-chip" />
            </div>
            <div className="admin-skeleton-panel admin-skeleton-calendar" />
          </>
        );
      case 'gallery':
        return (
          <>
            <div className="admin-skeleton-panel admin-skeleton-upload-card" />
            <div className="admin-skeleton-gallery-grid">
              {renderBlocks(6, 'admin-skeleton-gallery-card')}
            </div>
          </>
        );
      case 'users':
        return (
          <>
            <div className="admin-skeleton-toolbar">
              <div className="admin-skeleton-input admin-skeleton-input-lg" />
              <div className="admin-skeleton-chip" />
              <div className="admin-skeleton-chip" />
              <div className="admin-skeleton-chip" />
            </div>
            <div className="admin-skeleton-panel">
              <div className="admin-skeleton-table-head">
                {renderBlocks(5, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-table-body">
                {renderTableRows(5)}
              </div>
            </div>
          </>
        );
      case 'reservations':
        return (
          <>
            <div className="admin-skeleton-tabs">
              {renderBlocks(4, 'admin-skeleton-tab')}
            </div>
            <div className="admin-skeleton-toolbar admin-skeleton-toolbar-wrap">
              <div className="admin-skeleton-input admin-skeleton-input-xl" />
              <div className="admin-skeleton-input" />
              <div className="admin-skeleton-input" />
              <div className="admin-skeleton-input" />
              <div className="admin-skeleton-input" />
            </div>
            <div className="admin-skeleton-panel">
              <div className="admin-skeleton-table-head">
                {renderBlocks(6, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-table-body">
                {renderTableRows(6)}
              </div>
            </div>
          </>
        );
      case 'table':
      default:
        return (
          <>
            <div className="admin-skeleton-toolbar">
              <div className="admin-skeleton-input admin-skeleton-input-lg" />
              <div className="admin-skeleton-input" />
              <div className="admin-skeleton-input" />
            </div>
            <div className="admin-skeleton-panel">
              <div className="admin-skeleton-table-head">
                {renderBlocks(5, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-table-body">
                {renderTableRows(5)}
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className="admin-page admin-page-skeleton" aria-hidden="true">
      <div className="page-header">
        <div>
          <h1>{title}</h1>
          <p className="text-muted">{subtitle}</p>
        </div>
        {showAction && <div className="admin-skeleton-button" />}
      </div>
      {renderVariant()}
    </div>
  );
};

export default AdminPageSkeleton;
